import React from "react";
import styled from "styled-components";

const LegalP = styled.p`
  &&& {
    font-size: 0.875rem;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    line-height: 1.43;
    letter-spacing: 0.01071em;
    margin-bottom: 10px;
  }
`;

const LegalPHeader = styled.p`
  font-size: 0.93rem;
  font-weight: 550;
`;

export default function FullSandboxText() {
  return (
    <>
      <LegalP>
        Skyward will provide your company with access to a sandbox for the duration selected. Once we have received the signed NDA and payment for the sandbox,
        access details for the sandbox will be provided and the term will begin.
      </LegalP>
      <LegalP>Sandbox access includes 1 database selection (see selections on form).</LegalP>
      <LegalPHeader>Renewal</LegalPHeader>
      <LegalP>Sandboxes can be renewed at the going rate and duration at the time of renewal.</LegalP>
    </>
  );
}
